import React from 'react';

const ErrorPage: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '20%' }}>
            <h1 style={{ color: 'red' }}>Error</h1>
            <p>This feature is not available</p>
        </div>
    );
};

export default ErrorPage;